import React, { useContext } from 'react';
import { LinkProps, useLocation } from 'react-router-dom';

import { PagesFragment, PagesQuery } from '../generated/graphql';
import { TrackingContext } from '../TrackingContext';
import { Link } from './Link';

export type PageItem = NonNullable<PagesFragment['items']>[0];

interface PageItemLinkProps extends LinkProps {
  page: PagesQuery['pages'][0];
  pageItem: PageItem;
  as?: any;
  'data-testid'?: string;
}

export const PageItemLink: React.FC<PageItemLinkProps> = ({ page, pageItem, as, ...props }) => {
  const { track } = useContext(TrackingContext);
  const { pathname } = useLocation();

  let Component: any = Link;
  let source: string = 'dashboard';

  if (pathname.includes('preview')) {
    source = 'preview';
  }

  if (as) {
    Component = as;
  }

  return (
    <Component
      {...props}
      data-testid={props['data-testid'] || 'pageItemLink'}
      onClick={() =>
        track('Item Action Initiated', {
          action: 'edit',
          actionName: 'Edit Page Item',
          page: page.title,
          item: pageItem.type,
          source,
        })
      }
    />
  );
};
